// src/components/icons.tsx — heritage line icons, ported verbatim from the
// prototype bp-ui.jsx (BP_UI.Icon). 24×24 single-path SVGs, currentColor.

import type { CSSProperties } from "react";

export interface IconProps {
  s?: number;       // size (px)
  c?: string;       // stroke colour
  sw?: number;      // stroke width
  fill?: string;
  style?: CSSProperties;
}

function ic(paths: string, vb = "0 0 24 24") {
  return function IconCmp({ s = 18, c = "currentColor", sw = 1.7, fill = "none", style }: IconProps) {
    return (
      <svg
        width={s} height={s} viewBox={vb} fill={fill} stroke={c} strokeWidth={sw}
        strokeLinecap="round" strokeLinejoin="round"
        style={{ display: "block", ...style }}
        dangerouslySetInnerHTML={{ __html: paths }}
      />
    );
  };
}

export const Icon = {
  doc: ic('<path d="M6 2h7l5 5v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/><path d="M13 2v5h5"/><path d="M8.5 13h7M8.5 17h7M8.5 9h2"/>'),
  download: ic('<path d="M12 3v12"/><path d="M7.5 11l4.5 4 4.5-4"/><path d="M5 20h14"/>'),
  shield: ic('<path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6l7-3z"/>'),
  tablet: ic('<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M10.5 18h3"/>'),
  steam: ic('<path d="M5 16h12a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1V7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v2H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2z"/><circle cx="7" cy="18.5" r="1.5"/><circle cx="15" cy="18.5" r="1.5"/><path d="M16 6c0-1 1-1 1-2"/>'),
  diesel: ic('<rect x="3" y="6" width="18" height="11" rx="2"/><path d="M3 11h18"/><circle cx="7.5" cy="19" r="1.4"/><circle cx="16.5" cy="19" r="1.4"/><path d="M7 8.5h3M14 8.5h3"/>'),
  carriage: ic('<rect x="3" y="7" width="18" height="9" rx="1.5"/><path d="M7 7v9M12 7v9M17 7v9"/><circle cx="7.5" cy="18.5" r="1.2"/><circle cx="16.5" cy="18.5" r="1.2"/>'),
  diner: ic('<rect x="3" y="7" width="18" height="9" rx="1.5"/><path d="M9 7v9M15 7v9"/><path d="M6 11.5h0.01M18 11.5h0.01"/><circle cx="7.5" cy="18.5" r="1.2"/><circle cx="16.5" cy="18.5" r="1.2"/>'),
  signal: ic('<path d="M7 21V4"/><rect x="7" y="5" width="9" height="5" rx="1"/><circle cx="11.5" cy="7.5" r="1"/><path d="M5 21h4"/>'),
  track: ic('<path d="M8 3 5 21M16 3l3 18M4 8h16M3.5 14h17"/>'),
  cal: ic('<rect x="4" y="6" width="16" height="15" rx="2"/><path d="M4 10h16M9 3v4M15 3v4"/>'),
  grid: ic('<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>'),
  list: ic('<path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01"/>'),
  layers: ic('<path d="m12 2 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5M3 17l9 5 9-5"/>'),
  bell: ic('<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/>'),
  mega: ic('<path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z"/><path d="M15 8a4 4 0 0 1 0 8M18 5a8 8 0 0 1 0 14"/>'),
  check: ic('<path d="M20 6 9 17l-5-5"/>'),
  check2: ic('<path d="M18 7 9.5 15.5 6 12M22 7l-8.5 8.5"/>'),
  chevR: ic('<path d="m9 6 6 6-6 6"/>'),
  chevL: ic('<path d="m15 6-6 6 6 6"/>'),
  chevD: ic('<path d="m6 9 6 6 6-6"/>'),
  plus: ic('<path d="M12 5v14M5 12h14"/>'),
  edit: ic('<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>'),
  lock: ic('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>'),
  pin: ic('<path d="M12 22s7-7.5 7-13a7 7 0 0 0-14 0c0 5.5 7 13 7 13z"/><circle cx="12" cy="9" r="2.5"/>'),
  clock: ic('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
  alert: ic('<path d="M10.3 3.8 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.8a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>'),
  flag: ic('<path d="M4 21V4M4 4h11l-2 4 2 4H4"/>'),
  send: ic('<path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z"/>'),
  history: ic('<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 4v4h4"/><path d="M12 8v4l3 2"/>'),
  link: ic('<path d="M9 17H7A5 5 0 0 1 7 7h2M15 7h2a5 5 0 0 1 0 10h-2M8 12h8"/>'),
  users: ic('<circle cx="9" cy="8" r="3.2"/><path d="M2.5 19.5c1-3.2 3.5-5 6.5-5s5.5 1.8 6.5 5"/><path d="M16 11a3 3 0 0 0 0-6"/><path d="M16.5 19c.4-2 1.6-3.4 3.8-4"/>'),
  user: ic('<circle cx="12" cy="8" r="3.5"/><path d="M5 20c1.2-3.7 4-5.5 7-5.5s5.8 1.8 7 5.5"/>'),
  eye: ic('<path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>'),
  search: ic('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'),
  sparkle: ic('<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"/>'),
  sms: ic('<path d="M21 11.5a8.5 8.5 0 0 1-12.3 7.6L3 21l1.9-5.7A8.5 8.5 0 1 1 21 11.5z"/>'),
  swap: ic('<path d="M7 4 3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7"/>'),
  dot: ic('<circle cx="12" cy="12" r="4"/>'),
  warn: ic('<path d="M12 9v4M12 17h.01"/><circle cx="12" cy="12" r="9"/>'),
  close: ic('<path d="M18 6 6 18M6 6l12 12"/>'),
  filter: ic('<path d="M3 5h18l-7 8v5l-4 2v-7L3 5z"/>'),
  home: ic('<path d="M3 11l9-8 9 8M5 9.5V21h14V9.5"/>'),
  loco: ic('<path d="M4 17h13a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3h-2V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3"/><path d="M4 9h11"/><circle cx="7" cy="18.5" r="1.6"/><circle cx="14" cy="18.5" r="1.6"/><path d="M3 13h2"/>'),
  van: ic('<rect x="3" y="7" width="16" height="9" rx="1.5"/><path d="M19 10h2l1 3v3h-3"/><path d="M7 7v9"/><circle cx="8" cy="18" r="1.3"/><circle cx="17" cy="18" r="1.3"/><path d="M11 10h4v3h-4z"/>'),
  crew: ic('<path d="M14.7 6.3a3.5 3.5 0 0 1-4.8 4.8L4 17l3 3 5.9-5.9a3.5 3.5 0 0 1 4.8-4.8l-2.3 2.3-1.7-1.7 2.3-2.3z"/>'),
  cone: ic('<path d="M12 3 6 19h12L12 3z"/><path d="M8.5 12h7M2 19h20"/>'),
  water: ic('<path d="M12 3c3 4 5.5 7 5.5 10a5.5 5.5 0 0 1-11 0C6.5 10 9 7 12 3z"/>'),
  coal: ic('<path d="M5 14l3-4 4 2 3-3 4 5v3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"/><circle cx="9" cy="9" r="1"/>'),
  depot: ic('<path d="M3 10 12 4l9 6"/><path d="M5 9v11h14V9"/><rect x="9" y="13" width="6" height="7"/>'),
  move: ic('<path d="M5 12h14M13 6l6 6-6 6"/>'),
  at: ic('<path d="M12 22s7-7.5 7-13a7 7 0 0 0-14 0c0 5.5 7 13 7 13z"/><circle cx="12" cy="9" r="2.5"/>'),
} as const;

export type IconName = keyof typeof Icon;
